import { BehaviorSubject } from 'rxjs';
var BaseDialog = /** @class */ (function () {
    function BaseDialog() {
        this.loading = new BehaviorSubject(false);
        this.subs = [];
    }
    BaseDialog.prototype.ngOnDestroy = function () {
        this.subs.forEach(function (sub) { return sub && sub.unsubscribe(); });
    };
    BaseDialog.prototype.close = function () {
        this.dialogRef.close();
    };
    BaseDialog.prototype.addSubs = function () {
        var _a;
        var sub = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            sub[_i] = arguments[_i];
        }
        (_a = this.subs).push.apply(_a, sub);
    };
    return BaseDialog;
}());
export { BaseDialog };
